import React, { useState } from "react";
import Loader from "../../../Common/Loader/loader";
import { useLocation, useNavigate } from "react-router-dom";
import CustomDataTable from "../../../Common/ReportTable/ReportTable";
import * as XLSX from "xlsx";
import ExcelJS from "exceljs";
import { Formik, Form, Field } from "formik";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { DeleteGVPClearedRecord } from "../../../Apis/gvpClearanceReportApi";
import { toast } from "react-toastify";
import { formattedDate, getCurrentDateTime1, getCurrentISTDate } from "../../../Common/helper/helpar";
const GvpNotClearedInnerReport = () => {
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const {data, deleteOption,isValid,formatDate,shiftName} = location.state;
  const navigate = useNavigate();
  const [gvpList, setGvpList] = useState(data);
  const scvReportColumns = [
    {
      name: "S.No",
      selector: (row) => row["sno"],
      sortable: true,
      format: (row, rowIndex) => rowIndex + 1,
      width: "70px",
    },
    {
      name: "Corporation",
      selector: (row) => row["corporationName"],
      cell: (row) => <span>{row["corporationName"] || "N/A"}</span>,
      sortable: true,
    },
    {
      name: "Zone",
      selector: (row) => row["zoneName"],
      cell: (row) => (
        <span>
          {row["zoneName"]??"N/A"}
        </span>
      ),
      sortable: true,
      // width: "130px",
    },
    {
      name: "Circle",
      selector: (row) => row["circleName"],
      cell: (row) => (
        <span>
          {row["circleName"]??"N/A"}
        </span>
      ),
      sortable: true,
      // width: "130px",
    },
    {
      name: "Ward",
      selector: (row) => row["wardName"],
      cell: (row) => (
        <span>
          {row["wardName"]??"N/A"}
        </span>
      ),
      sortable: true,
      // width: "120px",
    },

    ...(isValid
      ? ''
      : [
        {
          name: <>Collection Point Name</>,
          selector: (row) => row?.collectionPointName || "N/A",
          cell: (row) => (
            <span>
              {row?.collectionPointName || "N/A"}
            </span>
          ),
          sortable: true,
          // width: "120px", // Reduced from 120px
        },
        {
          name: <>Collection Point Code</>,
          selector: (row) => row?.collectionPointCode || "N/A",
          cell: (row) => (
            <span>
              {row?.collectionPointCode || "N/A"}
            </span>
          ),
          sortable: true,
          width: "120px", // Reduced from 120px
        },
        {
          name: <>Collection Point Type</>,
          selector: (row) => row?.collectionPointTypeName || "N/A",
          cell: (row) => (
            <span>
              {row?.collectionPointTypeName || "N/A"}
            </span>
          ),
          sortable: true,
          width: "120px",
        },
        {
          name: <>Category</>,
          selector: (row) => row?.categoryName || "N/A",
          cell: (row) => <span>{row?.categoryName || "N/A"}</span>,
          sortable: true,
          width: "120px",
        },
        {
          name: <>LE Attached</>,
          selector: (row) => row?.leAttached,
          cell: (row) => <span>{row?.leAttached != null ? (row.leAttached ? "Yes" : "No") : "N/A"}</span>,
          sortable: true,
          width: "120px",
        },
        {
          name: <>LE Type</>,
          selector: (row) => row?.leType || "N/A",
          cell: (row) => <span>{row?.leType || "N/A"}</span>,
          sortable: true,
          width: "120px",
        },
      ]),

    // ...(isValid
    //   ? ''
    //   : [
    //     {
    //       name: <>Collection Point Code</>,
    //       selector: (row) => row?.collectionPointCode || "N/A",
    //       cell: (row) => (
    //         <span>
    //           {row?.collectionPointCode || "N/A"}
    //         </span>
    //       ),
    //       sortable: true,
    //       width: "120px", // Reduced from 120px
    //     },
    //     {
    //       name: <>Collection Point Type</>,
    //       selector: (row) => row?.collectionPointTypeName || "N/A",
    //       cell: (row) => (
    //         <span>
    //           {row?.collectionPointTypeName || "N/A"}
    //         </span>
    //       ),
    //       sortable: true,
    //       width: "120px", // Reduced from 120px
    //     },
    //   ]),
    {
      name: <>Latitude</>,
      selector: (row) => row["latitude"],
      cell: (row) => (
        <span>
          {row["latitude"]}
        </span>
      ),
      sortable: true,
    },
    {
      name: <>Longitude</>,
      selector: (row) => row["longitude"],
      cell: (row) => (
        <span>
          {row["longitude"]}
        </span>
      ),
      sortable: true,
    },
  ];

  const downloadAsExcel = async () => {
    const currentDate = new Date();
    const formattedDates = `${currentDate.getDate()}-${currentDate.getMonth() + 1
      }-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const cumulativeHeadingReport = `GVPs Not Cleared Inner Report as on ${formatDate?formattedDate(formatDate):getCurrentISTDate()} - ${shiftName} - (at ${getCurrentDateTime1()})`;
  
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("NotClearedGVPs");
  
    const boldFont = { bold: true };
  
    const downloadDateTime = `Reported on: ${formattedDates} ${formattedTime}`;
    const dateTimeRow = worksheet.addRow(["", "", downloadDateTime, "", ""]);
    worksheet.mergeCells(1, 3, 1, 5);
    dateTimeRow.getCell(3).font = boldFont;
    dateTimeRow.getCell(3).alignment = { horizontal: "center" };
  
    const cumulativeHeadingRow = worksheet.addRow(["", "", cumulativeHeadingReport, "", ""]);
    worksheet.mergeCells(2, 3, 2, 5);
    cumulativeHeadingRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      if (colNumber >= 3 && colNumber <= 5) {
        cell.font = boldFont;
        cell.alignment = { horizontal: "center" };
      }
    });
  
    worksheet.addRow([""]);
  
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Corporation",
      "Zone",
      "Circle",
      "Ward",
      ...(isValid ? [] : ["Collection Point Name"]),
      ...(isValid ? [] : ["Collection Point Code"]),
      ...(isValid ? [] : ["Collection Point Type"]),
      ...(isValid ? [] : ["Category"]),
      ...(isValid ? [] : ["LE Attached"]),
      ...(isValid ? [] : ["LE Type"]),
      "Latitude",
      "Longitude",
    ]);
  
    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "F6B1B1" },
      };
    });
  
    let totalLatitude = 0;
    let totalLongitude = 0;
    let validLatitudeCount = 0;
    let validLongitudeCount = 0;
    let totalTotalCP = 0;
    let totalPendingCP = 0;
    let totalPendingPercentage = 0;
    let validPendingPercentageCount = 0;
  
    data.forEach((item, index) => {
      const rowData = [
        index + 1,
        item.corporationName ?? "N/A",
        item.zoneName ?? "N/A",
        item.circleName ?? "N/A",
        item.wardName ?? "N/A",
        ...(isValid ? [] : [
          item.collectionPointName ?? "N/A",
          item.collectionPointCode ?? "N/A",
          item.collectionPointTypeName ?? "N/A",
          item.categoryName ?? "N/A",
          item.leAttached != null ? (item.leAttached ? "Yes" : "No") : "N/A",
          item.leType ?? "N/A",
        ]),
        item.latitude ?? "N/A",
        item.longitude ?? "N/A",
      ];
  
      worksheet.addRow(rowData).eachCell({ includeEmpty: true }, (cell, colNumber) => {
        cell.alignment = { horizontal: "left" };
      });
  
      if (item.latitude && !isNaN(parseFloat(item.latitude))) {
        totalLatitude += parseFloat(item.latitude);
        validLatitudeCount++;
      }
      if (item.longitude && !isNaN(parseFloat(item.longitude))) {
        totalLongitude += parseFloat(item.longitude);
        validLongitudeCount++;
      }
      if (item.totalCP && !isNaN(parseFloat(item.totalCP))) {
        totalTotalCP += parseFloat(item.totalCP);
      }
      if (item.pendingCP && !isNaN(parseFloat(item.pendingCP))) {
        totalPendingCP += parseFloat(item.pendingCP);
      }
      if (item.pendingPercentage && !isNaN(parseFloat(item.pendingPercentage))) {
        totalPendingPercentage += parseFloat(item.pendingPercentage);
        validPendingPercentageCount++;
      }
    });
  
    // const totalRow = worksheet.addRow([
    //   "",
    //   "Total",
    //   "", // Circle
    //   "", // Ward
    //   ...(isValid ? [] : ["", ""]), // Collection Point Code, Name
    //   validLatitudeCount > 0 ? (totalLatitude / validLatitudeCount).toFixed(6) : "N/A",
    //   validLongitudeCount > 0 ? (totalLongitude / validLongitudeCount).toFixed(6) : "N/A",
    
    // ]);
  
    // totalRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
    //   cell.font = boldFont;
    //   cell.alignment = { horizontal: "left" };
    // });
  
    worksheet.columns = [
      { width: 5 }, // S.No
      { width: 20 }, // Zone
      { width: 20 }, // Circle
      { width: 20 }, // Ward
      ...(isValid ? [] : [
        { width: 35 }, // Collection Point Code
        // { width: 25 }, // Collection Point Name
      ]),
      { width: 30 }, // Latitude
      { width: 25 }, // Longitude
      { width: 20 }, // Existing
      { width: 20 }, // GVP Not Cleared
      { width: 20 }, // Not Cleared Percentage
    ];
  
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "GVPsNotClearedInnerReport.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };
  
  const filterFields = {
    searchCircle: "",
    searchVehicleNumber: "",
    searchVehicleTypeName: "",
  };
  const searchReportedAtVehicleHandler = (values) => {
    const termCircle = values.searchCircle
      ? values.searchCircle.toLowerCase()
      : "";
    const termVehicleNumber = values.searchVehicleNumber
      ? values.searchVehicleNumber.toLowerCase()
      : "";
    const termVehicleTypeName = values.searchVehicleTypeName
      ? values.searchVehicleTypeName.toLowerCase()
      : "";

    const filteredData = data?.filter((item) => {
      const circleName = item?.circleName ? item.circleName.toLowerCase() : "";
      const vehicleNumber = item?.vehicleNumber ? item.vehicleNumber.toLowerCase()
        : "";
      const vehicleTypeName = item?.vehicleTypeName ? item.vehicleTypeName.toLowerCase() : "";

      const matchesCircle = !termCircle || circleName.includes(termCircle);
      const matchesVehicleNumber = !termVehicleNumber || vehicleNumber.includes(termVehicleNumber);
      const matchesVehicleTypeName = !termVehicleTypeName || vehicleTypeName.includes(termVehicleTypeName);

      return (
        matchesCircle &&
        matchesVehicleNumber &&
        matchesVehicleTypeName
      );
    });
    setGvpList(filteredData);
  };

  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">

            <div className="card mt-3">
              <div className="card-body">
                <div className="page-header">
                  <div className="d-flex justify-content-end ALIGN-ITEMS-CENTER mt-3">
                    {/* <Formik initialValues={filterFields}>
                      {({ handleChange, values }) => (
                        <Form>
                          <div className="row">
                            <div className="col-md-4">
                              <div className="form-group">
                                <Field
                                  name="searchCircle"
                                  placeholder="Search Circle"
                                  type="text"
                                  className="form-control bg-white"
                                  onInput={(e) => {
                                    handleChange(e);
                                    searchReportedAtVehicleHandler({
                                      ...values,
                                      searchCircle: e.target.value,
                                    });
                                  }}
                                />
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <Field
                                  name="searchVehicle"
                                  placeholder="Search Vehicle Number"
                                  type="text"
                                  className="form-control bg-white"
                                  onInput={(e) => {
                                    handleChange(e);
                                    searchReportedAtVehicleHandler({
                                      ...values,
                                      searchVehicleNumber: e.target.value,
                                    });
                                  }}
                                />
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <Field
                                  name="searchDriverName"
                                  placeholder="Search Vehicle Type"
                                  type="text"
                                  className="form-control bg-white"
                                  onInput={(e) => {
                                    handleChange(e);
                                    searchReportedAtVehicleHandler({
                                      ...values,
                                      searchVehicleTypeName: e.target.value,
                                    });
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </Form>
                      )}
                    </Formik> */}
                    <div className="d-flex">
                      <div>
                      <button className="btn btn-secondary me-2"
                        onClick={() => navigate(-1)}
                      >
                        Back
                      </button>
                        </div>
                      <div>
                      <button
                        className="btn btn-excel"
                        onClick={downloadAsExcel}
                      >
                        <i class="fa-solid fa-file-excel me-1 icon-container"></i> Excel
                      </button>
                      </div>
                     
                    </div>

                  </div>
                </div>
                <div className="top-header">
                  <span>
                    {" "}
                    GVPs Not Cleared Inner Report  {formatDate?formattedDate(formatDate):getCurrentISTDate()} - {shiftName} - (at {getCurrentDateTime1()})
                  </span>
                </div>

                <CustomDataTable data={gvpList} columns={scvReportColumns} />
              </div>
            </div>
          </div>
        </div>
      </div>
      {isLoading && <Loader />}
    </>
  );
};


export default GvpNotClearedInnerReport;
